<div class="sample">
  <img src="../../../assets/images/as_pal_Dummy.svg" alt="info" />
  <h1 class="sample__title">
    {{ "samplePage.title" | translate }}
  </h1>
  <p>
    {{ "samplePage.description" | translate }}
  </p>
</div>
